import { Location } from 'vue-router';

import { PackStatus } from '@/enums/packStatus.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { tryParseInt } from './number';

/**
 * Zwraca route do encji powiązanej z powiadomieniem
 *
 * @export
 * @param {string} entityType
 * @param {string} entityId
 * @returns
 */
export function getSystemMessageEntityRoute(entityType: string, entityId: string): Promise<Location> {
  return Promise.resolve().then<any>(() => {
    if (entityType === TableName.document) {
      return store.dispatch('document/get', tryParseInt(entityId)).then(async document => {
        const querySetting = await store.dispatch('setting/findPublic', {
          code: PublicSettings.SYSTEM_MESSAGE_ENTITY_ROUTE_QUERY,
          entityType: TableName.procedure,
          entityId: document.procedure.id.toString()
        });
        const query = (querySetting && JSON.parse(querySetting.value)) || {};
        return {
          name: 'documentView',
          params: { documentId: entityId, procedureId: document.procedure.id },
          query: { ...query, parentId: document.parentId ?? undefined }
        };
      });
    }

    if (entityType === TableName.procedure) {
      return { name: 'procedureView', params: { procedureId: entityId } };
    }

    if (entityType === TableName.document_pack) {
      return store.dispatch('documentPack/get', tryParseInt(entityId)).then(pack => ({
        name: 'documentPacks',
        params: { procedureId: pack.procedureId },
        query: { status: PackStatus.SENT }
      }));
    }
  });
}
